import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "list__panel-content" }
const _hoisted_2 = { class: "list__panel-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", {
      class: "list__panel-item",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('editWords', _ctx.words, _ctx.title)), ["stop"]))
    }, _toDisplayString(_ctx.Ti18N("account.wordsTable.panel.change")), 1),
    _createElementVNode("li", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: `/account/${_ctx.userID}/setupfolder?title=${_ctx.title}`
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.Ti18N("account.wordsTable.panel.addToSection")), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("li", {
      class: "list__panel-item",
      onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$emit('openModal'); _ctx.$emit('setOpenPanel', -1)})
    }, _toDisplayString(_ctx.Ti18N("account.wordsTable.panel.newWords")), 1),
    _createElementVNode("li", {
      class: "list__panel-item",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('setOpenPanel')))
    }, [
      _createVNode(_component_router_link, {
        to: `/account/${_ctx.userID}/delete?title=${_ctx.title}`
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.Ti18N("account.wordsTable.panel.delete")), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("li", {
      class: "list__panel-item",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('setOpenPanel')))
    }, _toDisplayString(_ctx.Ti18N("account.wordsTable.panel.cancel")), 1)
  ]))
}